import { IconButton, TextField } from "@mui/material";
import SearchIcon from '@material-ui/icons/Search';
import { useTheme } from '@mui/material/styles';

export default function SearchBar({setSearchQuery}) {
    const theme = useTheme()

    return (
        <form>
            <TextField
                color="secondary"
                id="search-bar"
                onInput={(e) => {
                setSearchQuery(e.target.value);
                }}
                label="Contact name"
                variant="outlined"
                placeholder="Search..."
                size="small"
            />
            <IconButton type="submit" aria-label="search">
                <SearchIcon style={{ fill: theme.palette.secondary.main }} />
            </IconButton>
        </form>
    )

}